package com.schoolconnect.app.datasource.network

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

object NetworkActivityTracker {
    private val _inFlightCount = MutableStateFlow(0)
    private val _blockingInFlightCount = MutableStateFlow(0)
    private val _nonBlockingScopeCount = MutableStateFlow(0)

    val inFlightCount: StateFlow<Int> = _inFlightCount.asStateFlow()
    val blockingInFlightCount: StateFlow<Int> = _blockingInFlightCount.asStateFlow()

    suspend fun <T> track(
        showBlockingLoader: Boolean = true,
        block: suspend () -> T
    ): T {
        val shouldShowBlockingLoader = showBlockingLoader && _nonBlockingScopeCount.value == 0
        _inFlightCount.update { current -> current + 1 }
        if (shouldShowBlockingLoader) {
            _blockingInFlightCount.update { current -> current + 1 }
        }
        return try {
            block()
        } finally {
            _inFlightCount.update { current -> (current - 1).coerceAtLeast(0) }
            if (shouldShowBlockingLoader) {
                _blockingInFlightCount.update { current -> (current - 1).coerceAtLeast(0) }
            }
        }
    }

    suspend fun <T> withoutBlockingLoader(block: suspend () -> T): T {
        _nonBlockingScopeCount.update { current -> current + 1 }
        return try {
            block()
        } finally {
            _nonBlockingScopeCount.update { current -> (current - 1).coerceAtLeast(0) }
        }
    }
}
